module.exports = __webpack_public_path__ + "static/media/IMG_1469-min.cc03a0cf.JPEG";